import React from 'react';
import BannerImg from '../assets/images/banner.jpeg';

const AboutOurCompany = () => {
  return (
    <section className="py-5 bg-light">
      <div className="container">
        {/* Company Intro */}
        <div className="row align-items-center mb-5">
          <div className="col-md-7">
            <h2 className="display-5 fw-bold mb-3 brand-text-color ">About Our Company</h2>
            <p className="generic-text text-dark mb-3">
              Broadway Building Solutions was born out of a simple realization — <span className="fw-semibold">construction teams deserve better support solutions.</span>
            </p>
            <p className="generic-text">
              With over a decade of experience in operations, logistics, and on-site coordination, co-founders <span className="fw-semibold">Madhur Gulati</span> and <span className="fw-semibold">Karan Singh</span> came together to bridge the gap between demanding project needs and reliable, fast-turnaround fencing services.
            </p>
            <p className="mb-4 generic-text">
              We don’t just deliver fences.<br />
              <span className="fw-semibold generic-text">We deliver peace of mind, professional service, and site-ready solutions — when and where you need them.</span>
            </p>
          </div>
          <div className="col-md-5 text-center">
            <img
              src={BannerImg}
              alt="Broadway Building Solutions"
              className="img-fluid rounded shadow"
              style={{ maxHeight: 260, objectFit: 'cover' }}
            />
          </div>
        </div>

        {/* Why Choose Broadway */}
        <div className="row mb-5">
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div className="p-4 bg-white rounded shadow-sm h-100">
              <h3 className="h4 fw-bold mb-3 brand-text-color">Why Choose Broadway?</h3>
              <ul className="list-unstyled generic-text">
                <li className="mb-2">
                  <span className="text-success me-2">✔</span> Premium Galvanized Fence Panels
                </li>
                <li className="mb-2">
                  <span className="text-success me-2">✔</span> Easy Installation &amp; Dismantling
                </li>
                <li className="mb-2">
                  <span className="text-success me-2">✔</span> Fast Response Times
                </li>
                <li className="mb-2">
                  <span className="text-success me-2">✔</span> Scalable Solutions for Any Project
                </li>
                <li>
                  <span className="text-success me-2">✔</span> Transparent Pricing. Zero Complications.
                </li>
              </ul>
            </div>
          </div>
          {/* Why Our Fences Stand Out */}
          <div className="col-lg-6">
            <div className="p-4 bg-white rounded shadow-sm h-100">
              <h3 className="h4 fw-bold mb-3 brand-text-color">Why Our Fences Stand Out?</h3>
              <ul className=" generic-text">
                <li>  
                  <span className="fw-semibold">Built Tough:</span> Weather-resistant, anti-climb, and sturdy under pressure.
                </li>
                <li>  
                  <span className="fw-semibold">Swift Setup:</span> Installed by trained professionals, with minimal site disruption.
                </li>
                <li>
                  <span className="fw-semibold">Compliance-Ready:</span> Designed to meet municipal and provincial site safety standards.
                </li>
                <li>  
                  <span className="fw-semibold">Cost-Effective:</span> Competitive pricing with no compromise on quality.
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="row">
          <div className="col-12 text-center">
            <a href="/contact-us" className="btn btn-lg brand-orange text-white px-3 py-2">
              Get a Free Quote
            </a>
           
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutOurCompany;